import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-8626a670"), n = n(), _popScopeId(), n); };
var _hoisted_1 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("h1", null, "Scarica Allegati", -1); });
var _hoisted_2 = ["onClick"];
import { onMounted } from "vue";
import { ref } from "vue";
import { initFlowbite } from "flowbite";
import { patientStore } from "@/store/patient";
import { storeToRefs } from "pinia";
import { Modal } from "flowbite-vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'esamiDownload',
    emits: ["cancel"],
    setup: function (__props, _a) {
        var __expose = _a.expose, emit = _a.emit;
        var store = patientStore();
        var patient = storeToRefs(store).patient;
        var esami = ref({});
        var alertConfirmMessage = ref(null);
        var showConfirm = ref(false);
        var resolvePromise;
        var errors = ref([]);
        onMounted(function () {
            errors.value = [];
            initFlowbite();
        });
        function openModal(message, esamiinput) {
            esami.value = esamiinput;
            alertConfirmMessage.value = message;
            showConfirm.value = true;
            return new Promise(function (resolve) {
                resolvePromise = resolve;
            });
        }
        function download(row) {
            store.fetchDownloadUrl(row).then(function (data) {
                window.open(data.data, "_blank");
            });
            resolvePromise(true);
        }
        function closeModal() {
            showConfirm.value = false;
            if (!resolvePromise)
                return;
            resolvePromise(false);
            emit("cancel");
        }
        __expose({ openModal: openModal });
        return function (_ctx, _cache) {
            return (showConfirm.value)
                ? (_openBlock(), _createBlock(_unref(Modal), {
                    key: 0,
                    onClose: closeModal
                }, {
                    header: _withCtx(function () { return [
                        _hoisted_1
                    ]; }),
                    body: _withCtx(function () { return [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(esami).allegati, function (item, key) {
                            return (_openBlock(), _createElementBlock("div", { key: key }, [
                                _createElementVNode("button", {
                                    onClick: function ($event) { return (download(_unref(esami).id_allegati[key])); }
                                }, _toDisplayString((item)), 9, _hoisted_2)
                            ]));
                        }), 128))
                    ]; }),
                    _: 1
                }))
                : _createCommentVNode("", true);
        };
    }
});
